import { INSPECTION_SUMMARY_PARTS } from 'charts/components/triplet/inspectionSummaryParts';
import { INSPECTION_TRIPLET_CHART_ID } from 'charts/constants/catalogInspectionCharts';
import { useAnalyticsChart } from 'charts/hooks/useAnalyticsChart';
import { useInspectionChartRuntime } from 'charts/hooks/inspection/InspectionChartRuntimeContext';
import { formatTranslation } from 'intl';
import { InspectionTranslationKeys } from 'intl/keys';
import React, { ReactElement, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { MemoInspectionSummarySubsectionPresentational } from './presentational';

export function InspectionSummarySubsection(): ReactElement | null {
  const intl = useIntl();
  const { runtimeById } = useInspectionChartRuntime();
  const chartRuntime = runtimeById.inspectionTriplet;
  const chart = useAnalyticsChart(INSPECTION_TRIPLET_CHART_ID);

  const parts = useMemo(
    () =>
      INSPECTION_SUMMARY_PARTS.map(({ part, titleId, subtitleId }) => ({
        part,
        title: formatTranslation(intl, titleId),
        subtitle: formatTranslation(intl, subtitleId),
      })),
    [intl]
  );

  if (!chartRuntime || !chart) {
    return null;
  }

  return (
    <MemoInspectionSummarySubsectionPresentational
      sectionLabel={formatTranslation(intl, InspectionTranslationKeys.summaryChart)}
      parts={parts}
      chart={chart}
      chartRuntime={chartRuntime}
    />
  );
}

export const MemoInspectionSummarySubsection = React.memo(
  InspectionSummarySubsection
);
